/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Col_CreatedInputs */

const cs_documents_col_created = /** @type {(inputs: Documents_Col_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořeno`)
};

const en_documents_col_created = /** @type {(inputs: Documents_Col_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Documents_Col_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_col_created = /** @type {((inputs?: Documents_Col_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Col_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_col_created(inputs)
	return cs_documents_col_created(inputs)
});